import { useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'

import communitiesApi from '../api/communities'

export const useCommunitiesStore = defineStore('communities', {
  state: () => ({
    communities: useLocalStorage('communities', []),
    _updateCommunitiesPromise: null,
  }),

  actions: {
    updateCommunities() {
      if (this._updateCommunitiesPromise) {
        return this._updateCommunitiesPromise
      }

      const fetchAndSetCommunities = async () => {
        try {
          const response = await communitiesApi.getCommunities()
          this.communities = response.data
          return response
        } finally {
          this._updateCommunitiesPromise = null
        }
      }

      this._updateCommunitiesPromise = fetchAndSetCommunities()
      return this._updateCommunitiesPromise
    },
  },
})
